import React from "react";
import Cleave from "cleave.js/react";

const PriceField = (props: any) => {
  const { placeholder, value, register, errors, label, clearErrors, setValue } = props;
  return (
    <div className="w-full my-2 text-left mt-4">
      <label htmlFor="">{label}</label>
      <Cleave
        type="text"
        className="w-full focus:outline-none bg-[#EEF5F4] p-2 mt-1"
        placeholder={placeholder}
        value={value}
        autoComplete="off"
        onBlur={(e) => clearErrors(register.name)}
        onChange={(e) => setValue(register.name, e.target.value)}
        options={{
          numeral: true,
          numeralDecimalMark: ".",
          numeralDecimalScale: 2,
          numeralPositiveOnly: true,
          delimiter: ""
        }}
      />
      {errors && (
        <p className="text-red-500 text-xs my-1">{errors?.message}</p>
      )}
    </div>
  );
};

export default PriceField;
